import React from 'react';
import classnames from 'classnames';
import CoreStar from '@wix/da-ds/pkg/Icons/CoreStar';
import s from './UserSymbol.scss';
export var UserSymbol = function (_a) {
    var userType = _a.userType, className = _a.className;
    if (userType === 'regular' || userType === 'buyer' || userType === 'banned') {
        return null;
    }
    if (userType.includes('core')) {
        return (React.createElement(CoreStar, { corePackage: userType, className: s['core-symbol'] }));
    }
    return (React.createElement("div", { className: classnames(s['symbol'], s[userType]), "aria-hidden": true }));
};
UserSymbol.displayName = 'UserSymbol';
export default UserSymbol;
//# sourceMappingURL=UserSymbol.js.map